import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface ChangeOrderWithDetails {
  id: string;
  description: string;
  reason: string;
  costImpact: number;
  status: 'pending' | 'approved' | 'rejected' | 'executed';
  createdAt: number;
  requestedByName: string;
  approvedByName?: string;
  approvedAt?: number;
  items: any[];
}

export const changeOrderService = {
  getChangeOrders: async (projectId: string): Promise<ChangeOrderWithDetails[]> => {
    const response = await fetch(`${API_URL}/api/change-orders?projectId=${projectId}`, {
      headers: { 'Authorization': `Bearer ${authService.getToken()}` },
    });
    if (!response.ok) throw new Error('Error al obtener órdenes de cambio');
    const data = await response.json();
    return data.data || [];
  },
  getCumulativeImpact: async (projectId: string) => {
    return { totalImpact: 0, approvedCount: 0, pendingCount: 0 };
  },
  createChangeOrder: async (data: any) => {
    return { success: true };
  },
  approveChangeOrder: async (id: string) => {
    // TODO: Implementar
  },
  rejectChangeOrder: async (id: string, reason: string) => {
    // TODO: Implementar
  },
  executeChangeOrder: async (id: string) => {
    // TODO: Implementar
  },
};